export default __webpack_public_path__ + "static/media/wanna7.74a88169.webp";